export const formValidationWrapp = function () {

    const validate = (validationsObj) => {
        const errors = {};
        Object.entries(validationsObj).map(([inId, validArr]) => {
            const inVal = document.querySelector(`form[class*=cl-stt] input[id*=${inId}]`);
            if (!inVal) return true;
            const hasErrors = validArr.map(rule => {
                rule.setInVal(inVal.value);
                return !rule.isValid() ? rule.getErrMess() : '';
            }).filter(v => v.trim());
            if (hasErrors.length) {
                errors[inId] = hasErrors;
            }
        });
        return errors;
    }

    const notEmpty = function (mess = 'field cannot be empty', val) {
        const getErrMess = () => mess;
        const setInVal = (inVal) => val = inVal;
        const isValid = () => String(val).trim();
        return { isValid, getErrMess, setInVal };
    }

    const formProps = [...document.querySelectorAll('form[class*=cl-stt] input[id*=clk]')];
    const validations = {
        clk_token: [notEmpty()]
    }

    const setSumitBtnState = (active = false) => {
        const btnSubmitEle = document.querySelector('form[class*=cl-stt] input[type*=submit]')
        btnSubmitEle.disabled = !active;
    }

    const setErrorsToFlds = () => {
        var formField = document.querySelectorAll('form *[id*="clk"]');

        formField.forEach(field => {
          var err = document.querySelector(`*[id^="setting-error-${field.id}-error"]`);
          // console.log(err);
          if (err) {
            function fldError() {
              field.style.background = "#FFF1F1";
              field.style.border = "1px solid #F14E4F";
            }
            fldError();
          }
        });
    }

    const checkFormValidicity = () => {
        const errors = validate(validations);
        // check is form has errors
        if (Object.keys(errors).length) setSumitBtnState();
        // if form has no error submit button is activated
        else setSumitBtnState(true);
    }

    const init = () => {
        formProps.forEach(inEle => {
            inEle.addEventListener('input', ({ target = null }) => {
                if (target) checkFormValidicity();
            });
        });
        checkFormValidicity();
        // add css class to fields woth errors
        setErrorsToFlds();
    }

    return { init };
}